import React from "react";

const PrivacyRender = () => {
  return (
    <div className="policy bg-light py-5" style={{ fontSize: 16 }}>
      <h1 className="container text-center bg-light mt-2 mt-md-5 mb-4 mb-md-5">Privacy Policy</h1>
      <div className="container-xxl">
        <div className="bg-white p-md-5 p-4">
          <div className="cell mb-4 mb-md-5">
            <h2 className="sub mb-4 mb-md-5">1. Introduction</h2>
            <p className="mb-3 mb-md-4">
              HitPaw Technology Co., Ltd is committed to respecting and safeguarding your privacy. Please read the following Privacy Policy (this
              "Policy") carefully to help you understand what data we collect, why we collect it and what we do with it. If you do not agree with our
              policies and practices, your choice is not to use the Website. By accessing or using the Website, you agree to this privacy policy. This
              policy may change from time to time. Your continued use of the Website after we make changes is deemed to be acceptance of those
              changes, so please check the policy periodically for updates.
            </p>
            <p className="mb-3 mb-md-4">
              This Policy applies to personal information collected by all HitPaw websites, products and services. We are committed to processing
              Personal Information under applicable data protection laws. The data is processed exclusively on the basis of General Data Protection
              Regulation ("GDPR").
            </p>
            <p className="mb-3 mb-md-4">Effective: January 15, 2022.</p>
          </div>
          <div className="cell mb-4 mb-md-5">
            <h2 className="sub mb-4 mb-md-5">2. What Personal Information Do We Collect</h2>
            <p>
              To provide a better experience for you, we collect a few different types of information from you when you come to our website or use our
              service and software.
            </p>
            <p className="fw-bold fs-6">2.1 Personal data related to your visit to our website, purchase and use of our products</p>
            <p className="fw-bold">(1) Data collected when you visit our website：</p>
            <p>
              When a user visits our website, we will collect the user's clicks on the website, the pages visited, the date and time of the user's
              visit to the website, and the source of the user. In most cases, such collections are collected anonymously. We may share your
              information with trusted third parties who adhere to HitPaw’s commitment to protect your privacy. To comply with applicable laws or
              respond to valid legal procedures, we may also disclose your personal information to law enforcement or other government agencies.
            </p>
            <p className="fw-bold">(2) The data you submit to us:</p>
            <p>
              The personal information we collect through the collection form in the purchase process or other processes includes: your name, profile
              picture, gender, age, country, email address, mailing address, postal code, phone number, payment information (credit card information/
              Debit card information or other payment/billing information), etc.
            </p>
            <p className="fw-bold">(3) Data collected when you use our products </p>
            <p>
              We have different types of products, and different products may collect different data. Generally speaking, if you use our products, we
              may collect the following data:
            </p>
            <ul>
              <li className="mb-2">Your product serial number;</li>
              <li className="mb-2">
                We collect information about the products you use and your use of the products, including but not limited to startup data, function
                usage information, page clicks and operations, and registration information;
              </li>
              <li className="mb-2">
                Your local device information, including but not limited to your device model and configuration information, operating system,
                software version, MAC address, IP address, operation log information, the size and format of the file you operate, etc;
              </li>
              <li className="mb-2">
                Desktop product operation log, operation crash report, etc. When a user crashes during the use of the product, we will ask the user if
                they are willing to send the original document to us in order to confirm the cause of the crash and solve the crash problem. Only with
                the user's consent, we will collect the user's original document information;
              </li>
              <li className="mb-2">
                Internet product log information. Every time you visit a website, your browser will send certain information to our server. This
                information is automatically recorded by our server. The server log file includes the following information: IP address, browser type,
                web request from the browser, referencing or exiting page, number of clicks, login page, URL, viewed page, and other related
                information.
              </li>
            </ul>
            <p className="fw-bold fs-6">2.2 Cookie Information</p>
            <p>
              Cookies are small pieces of text containing a string of alphanumeric characters which are stored on the browser or your device hen you
              visit a website or application. Cookies can help the website to remember information about your visit (such as your preferences), which
              can make it easier to visit the site again. Cookies can also help us obtain other information, such as the daily visitors and the most
              visited pages of the website. Cookies are unique and can only be read by the server assigned to them. They cannot be executed as code or
              spread viruses.
            </p>
            <p>
              Using cookies help us better understand user behavior, tell us which parts of our websites people have visited, and facilitate and
              measure the effectiveness of advertisements and web searches. You can change the settings in your browser to prevent cookies if you do
              not want to have a cookie set when you visit our website. However, by doing so, you may not have full access to all the web pages.
            </p>
          </div>
          <div className="cell mb-4 mb-md-5">
            <h2 className="sub mb-4 mb-md-5">3. What Purposes Do We Use the Collected Information</h2>
            <p>To provide better services to users, your information may be desensitized and analyzed. We may use your personal information to:</p>
            <ul>
              <li className="mb-2">Necessary to realize product functions;</li>
              <li className="mb-2">Verify your identity to complete the order or provide related services;</li>
              <li className="mb-2">
                As necessary for the user to conclude a contract with HitPaw. So that we can obtain the necessary information to identify and send
                bills to the user and charge according to the payment method agreed by the user;
              </li>
              <li className="mb-2">
                Verify your identity and provide customer service or support. If you want to cancel your account, you can contact our customer service
                at any time;
              </li>
              <li className="mb-2">
                Analyze your use of our website and products to better understand how you use them. So that we can improve our products, services and
                user experience to attract and retain more users;
              </li>
              <li className="mb-2">Provide personalized information;</li>
              <li className="mb-2">
                Providing your email address to HitPaw means that you agree to receive notifications on your email address. To inform you of our
                latest product information, software updates, promotional activities and after-sales service. If you do not want to receive this
                information, you can exit our mailing list at any time;
              </li>
              <li className="mb-2">HitPaw's internal statistics and analysis purposes;</li>
              <li className="mb-2">For refund management purposes;</li>
              <li className="mb-2">Other uses with your consent.</li>
            </ul>
          </div>
          <div className="cell mb-4 mb-md-5">
            <h2 className="sub mb-4 mb-md-5">4. Transfer of Personal Data</h2>
            <p>
              HitPaw transfers the collected personal data to recipients located outside the European Union. These destinations may not have laws
              protecting users' personal data like the European Union.
            </p>
            <p>
              HitPaw ensures that user personal data processed by HitPaw or its suppliers and partners operating outside the European Union are safely
              processed and protected from unauthorized access, loss or destruction, illegal processing, and anything that is incompatible with this
              privacy policy. The purpose of the inconsistent handling policy.
            </p>
            <p>Please read the following information about data transfer:</p>
            <ul className="list-dot ">
              <li className="mb-2">
                HitPaw may transmit your email address and other necessary information (such as your name) to unexpected third-party email sending
                service providers in the European Union in order to send you notification emails;
              </li>
              <li className="mb-2">
                HitPaw may transfer your payment information to a payment processing company outside the EU to process the transaction;
              </li>
              <li className="mb-2">
                HitPaw may use third-party cookies and tracking tools (such as AdWords, Bing, bugsplat, Criteo, discus, fabric, Facebook, FireBase,
                Flurry, Google Analytics, Hotjar, LinkedIn, Pardot, Quora) to track information about how users use the website And products, such
                website usage data and product usage data may be sent to and stored on third-party servers located outside the European Union. Such
                third-party cookies and tracking tools may send tracking data or analysis reports to HitPaw for the above-mentioned purposes. Most
                third-party cookies and tracking tools process your personal data anonymously;
              </li>
              <li className="mb-2">HitPaw may store the collected personal data on the server rented from the server provider;</li>
              <li className="mb-2">
                HitPaw may transfer your relevant personal information to social media outside Europe, third-party online forums, other marketing
                platforms and service providers that have completed relevant services;
              </li>
              <li className="mb-2">
                HitPaw may transfer your relevant personal information to fraud monitoring and prevention providers outside the European Union to
                complete related services;
              </li>
            </ul>
          </div>
          <div className="cell mb-4 mb-md-5">
            <h2 className="sub mb-4 mb-md-5">5. How Do We Disclose Your Personal Information</h2>
            <p>
              We will handle your personal data carefully and confidentially, and will only pass it to third parties within the scope of our
              subordinates, and will not exceed the scope. We will not share, sell, rent or trade personal data with third parties for promotional
              purposes.
            </p>
            <ul className="list-dot ">
              <li className="mb-2">
                Disclosure after obtaining your explicit prior consent. We will inform you in advance of the purpose of public disclosure and the type
                of information disclosed. After obtaining your explicit consent, we will publicly disclose the information authorized to be disclosed;
              </li>
              <li className="mb-2">
                Affiliated companies: Your information may be shared within HitPaw affiliates, but we will only share necessary personal information
                for the purpose of providing you with HitPaw website product-related functions and services, and are bound by the stated purpose of
                this privacy policy;
              </li>
              <li className="mb-2">
                In order to provide the products and services you request, it must be shared with trusted third parties for project cooperation, but
                we will only share your personal information for legal, legitimate, necessary, specific, and clear purposes, and will only share and
                provide Personal information necessary for the service. Our partners have no right to use the shared personal information for any
                other purpose. Our partners include the following types:
                <ul className="mt-2">
                  <li className="mb-2">
                    Suppliers of goods or technical services. We may share your personal information with third parties who support our functions.
                    These supports include payment services, data processing, etc. The purpose of our sharing of this information is to realize the
                    core shopping functions of our products and services. For example, we need to share your order number and order amount with a
                    third-party payment institution to confirm your payment instructions and complete the payment, etc;
                  </li>
                  <li className="mb-2">
                    Third-party merchants. We must share your order information and necessary information related to the transaction with third-party
                    merchants to fulfill your needs for purchasing goods or services from them, and urge them to complete subsequent after-sales
                    service;
                  </li>
                </ul>
              </li>
              <li className="mb-2">
                According to the relevant provisions of the law, or the requirements of the administrative and judicial institutions, to disclose to
                third parties, administrative and judicial institutions. We will also conduct corresponding reviews and provide reasonable information
                on this requirement;
              </li>
              <li className="mb-2">
                If you are a qualified intellectual property complaint and have filed a complaint, you should disclose it to the respondent at the
                request of the respondent, so that both parties can deal with possible rights disputes;
              </li>
              <li className="mb-2">
                Directly related to national security, national defense security, criminal investigation, prosecution, trial, judgment, execution,
                social public security and interests;
              </li>
              <li className="mb-2">
                Any leakage of personal privacy information of users due to hacker attacks, computer virus intrusion and other force majeure events;
              </li>
              <li className="mb-2">Other disclosures deemed appropriate in accordance with laws, regulations or website policies;</li>
            </ul>
          </div>
          <div className="cell mb-4 mb-md-5">
            <h2 className="sub mb-4 mb-md-5">6. Business Partners and Third-party Service Providers</h2>
            <p>
              At times HitPaw may make certain personal information available to third-party credit card processors to fulfill customer orders and
              deliver products. HitPaw uses a secure server hosted by MyCommerce, Share-it, and other 3rd party credit card processors that encrypt
              all the customer's personal information before it is sent to us, including name, address, credit card number, credit card expiration
              date, etc. Encryption works to prevent any malicious use of your personal information. Your credit card information is only used for
              online transactions.
            </p>
            <p>
              <span className="fw-bold">MyCommerce:</span> MyCommerce offers a self-service SaaS eCommerce platform to support software sales for B2B
              or B2C with nearly 25 years of industry experience. HitPaw uses MyCommerce to provide you with very secure and fast online purchases.
              Check<a href="https://www.mycommerce.com/privacy-policy/"> Privacy Policy of MyCommerce</a>.
            </p>
            <p>
              <span className="fw-bold">Share-it:</span> Share-it offers an easy and quick solution to selling software and digital products online
              globally. Check
              <a href="https://order.shareit.com/info/privacy_statement"> Privacy Policy of Share-it</a>.
            </p>
            <p>
              <span className="fw-bold">Paddle:</span> Paddle offers a self-service SaaS eCommerce platform to support software sales for B2B or B2C.
              Check 
              <a href="https://paddle.com/privacy/"> Privacy Policy of Paddle</a>.
            </p>
          </div>
          <div className="cell mb-4 mb-md-5">
            <h2 className="sub mb-4 mb-md-5">7. How Do We Protect Your Personal Information</h2>
            <p>
              We have used industry-standard security protection measures to protect the personal information you provide to prevent unauthorized
              access, public disclosure, use, modification, damage or loss of data. We will take all reasonable and feasible measures to protect your
              personal information and ensure that the collected information is only used for the purposes specified in this privacy policy.
            </p>
            <p>
              We will take all reasonable and feasible measures to ensure that irrelevant personal information is not collected. We promise that the
              storage time of your personal information will always be within a reasonable and necessary period required by law or to realize product
              functions and services. During your use of our products and services, we will store your personal information necessary to provide you
              with our products and services. If you apply to cancel your account, we will delete or anonymize your personal information within 15
              days after you cancel your account.
            </p>
            <p>
              In the unfortunate event of a personal information security incident, we will promptly inform you in accordance with the requirements of
              laws and regulations: the basic situation and possible impact of the security incident, the disposal measures we have taken or will
              take, and what you can independently prevent and reduce risks Suggestions, remedies for you, etc. We will promptly inform you of the
              relevant situation of the incident by email, letter, telephone, push notification, etc. If it is difficult to inform the subject of
              personal information one by one, we will adopt a reasonable and effective way to issue an announcement. At the same time, we will also
              proactively report the handling of personal information security incidents in accordance with the requirements of the regulatory
              authorities.
            </p>
            <p>
              After you cancel your account, we will stop providing products and services based on that account, and delete your corresponding
              personal data without special legal requirements.
            </p>
            <p>
              You can contact us at <span className="text-primary">support@hitpaw.com</span> to apply for cancellation of your account.
            </p>
          </div>
          <div className="cell mb-4 mb-md-5">
            <h2 className="sub mb-4 mb-md-5">8. Children's Privacy</h2>
            <p>
              In order to protect children's privacy, HitPaw does not allow children under 13 to register and use our services. We will not collect
              any information from children under the age of 13. We ask children under 13 not to send us any of their personally identifiable
              information, such as email address, name, contact number or address. If we obtain personal information from a child under the age of 13
              without parental consent, we will delete the obtained information as soon as possible. Users who believe that we hold information about
              children under the age of 13, please contact us at <span className="text-primary">support@hitpaw.com</span>.
            </p>
            <p>
              If you are the guardian of a minor, when you have any questions about the personal information of the minor you are guarding, please
              contact us through the above contact information.
            </p>
          </div>
          <div className="cell mb-4 mb-md-5">
            <h2 className="sub mb-4 mb-md-5">9. Your Rights</h2>
            <p>
              If the laws of your jurisdiction provide for the following rights, you may have the following rights and you can consult your legal
              advisor. According to the GDPR, EU residents have the following rights.
            </p>
            {/* <p>Untitled:</p> */}
            <ul>
              <li className="mb-2">
                The right to be informed: Users have the right to obtain clear, transparent and easy-to-understand information about how HitPaw
                collects and uses personal data and their rights. This is why HitPaw provides users with the information in this privacy policy.
              </li>
              <li className="mb-2">
                The right to access: Users have the right to access their personal data (if HitPaw is processing it) and certain other information
                (similar to the information provided in this privacy policy).
              </li>
              <li className="mb-2">
                The right of correction: If personal data is inaccurate or incomplete, users have the right to correct their personal data.
              </li>
              <li className="mb-2">
                The right of erasure: This "right to be forgotten" allows users to request the deletion or removal of their personal data without a
                compelling reason to continue using HitPaw. This is not a general right of erasure; there are exceptions.
              </li>
              <li className="mb-2">
                The right to restrict processing: In some cases, users have the right to "block" or prohibit further use of their personal data.
              </li>
              <li className="mb-2">
                The right to data portability: The user has the right to receive personal data provided to HitPaw in a structured, commonly used and
                machine-readable format, and has the right to transmit these data to another controller.
              </li>
              <li className="mb-2">
                The right to object to processing: Users have the right to object to the processing of their personal data at any time based on their
                specific circumstances.
              </li>
              <li className="mb-2">
                The right to lodge a complaint: Users have the right to lodge a complaint with their national supervisory authority (in France, CNIL)
                regarding the way HitPaw processes or processes their personal data.
              </li>
              <li className="mb-2">
                The right to withdraw consent: If the user has agreed to HitPaw's specific processing of their personal data, the user has the right
                to withdraw his consent at any time. If the user does this, it does not mean that anything that Wondershare does with the user's
                personal data with its consent is illegal).
              </li>
              <li className="mb-2">
                The right to define instructions: Users have the right to define general or specific instructions regarding the storage, deletion and
                use of their personal data after death.
              </li>
            </ul>
          </div>
          <div className="cell mb-4 mb-md-5">
            <h2 className="sub mb-4 mb-md-5">10. Revision of This Privacy Policy</h2>
            <p>
              HitPaw reserves the right to update or change this Policy at any time. Any changes we may make to our privacy policy in the future will
              be posted on this page and, where appropriate, notified to you via different channels, such as by posting a notice on our websites or by
              providing a notice directly to you. For any questions, please enter our Customer Service Center for help. Thank you.
            </p>
          </div>
          <div className="cell">
            <h2 className="sub mb-4 mb-md-5">11. How to Contact Us</h2>
            <p>
              If you have any questions, comments or suggestions about this privacy policy or personal information, please contact us in the following
              ways:
            </p>
            <ul>
              <li className="mb-2">Please enter our customer service center for help;</li>
              <li className="mb-2">
                Customer service email: <span className="text-primary">support@hitpaw.com</span>;
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyRender;
